import { Button } from '../components/button'
import { defineComponent, reactive, Teleport } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from './state'
import CheckBox from '../components/checkbox'
import Section from '../components/section'
import { Dialog } from '../components/dialog'

export default defineComponent({
  name: 'page.stage1',
  setup () {
    const store = useStore()
    const router = useRouter()

    store.initStage(1)

    const state = reactive({
      showInvalidPopup: false,
    })

    const goToNext = () => {
      if (store.stageValidity === true) {
        router.push({
          name: 'stage2',
        })
      } else {
        state.showInvalidPopup = true
      }
    }

    return () => [
      <div class="py-20">
        <Section onlyMobile={false}>
          <div class="text-[#245058] basis-full font-bold text-3xl text-center">
            설문참여를 위해 정보를 입력해주세요
          </div>
        </Section>
        <Section onlyMobile={false} class="mt-12">
          <div class="text-xl text-center basis-full">
            이전에{' '}
            <a href="https://mindle.kr" target="_blank">
              마인들링
            </a>
            을 한번이라도 구매해서 사용해 본적이 있다/없다
          </div>
        </Section>
        <Section onlyMobile={true}>
          <div class="basis-1/2 pr-2">
            <CheckBox
              label="있다"
              value="true"
              active={store.이전사용유무 === true}
              onSelect={() => (store.이전사용유무 = true)}
            />
          </div>
          <div class="basis-1/2 pl-2">
            <CheckBox
              label="없다"
              value="false"
              active={store.이전사용유무 === false}
              onSelect={() => (store.이전사용유무 = false)}
            />
          </div>
        </Section>
        <Section onlyMobile={true}>
          <Button
            class="w-full"
            disabled={store.이전사용유무 === undefined}
            onClick={goToNext}
          >
            계속
          </Button>
        </Section>
      </div>,
      <Teleport to="body">
        <Dialog
          visible={state.showInvalidPopup}
          showCloseButton={true}
          closeOnBackdrop={true}
          onClose={() => {
            router.push({
              name: 'main',
            })
          }}
        >
          <div class="p-8 text-center basis-full">
            참여 가능한 대상이 아닙니다
          </div>
        </Dialog>
      </Teleport>,
    ]
  },
})
